// extracted by mini-css-extract-plugin
module.exports = {"refeicoes":"Refeicoes_refeicoes__3-XpK","containerRefeicoes":"Refeicoes_containerRefeicoes__3QKRb"};